import React, { useState } from 'react'
import { toast } from 'sonner'
import { useQueryClient } from 'react-query'
import { useAuthStore } from '@/store/authStore'
import { taskService } from '@/services/taskService'
import RichTextEditor from './RichTextEditor'
import { Button } from '@/components/ui/button'

const TaskComments = ({ taskId, projectId, mentionUsers = [] }) => {
  const { user } = useAuthStore()
  const queryClient = useQueryClient()
  const [content, setContent] = useState('')
  const [loading, setLoading] = useState(false)
  // key forces RichTextEditor remount to clear content after submit
  const [editorKey, setEditorKey] = useState(0)

  const handleSubmit = async () => {
    const text = content.replace(/<[^>]*>/g, '').trim()
    if (!text) return toast.error('Comment cannot be empty')

    setLoading(true)
    try {
      await taskService.addComment(projectId, taskId, content)
      queryClient.invalidateQueries(['projects', String(projectId), 'tasks', String(taskId)])
      setContent('')
      setEditorKey(k => k + 1)
      toast.success('Comment added')
    } catch (err) {
      toast.error(err.response?.data?.error || 'Failed to add comment')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="space-y-2">
      <RichTextEditor
        key={editorKey}
        content=""
        onChange={setContent}
        placeholder="Add a comment..."
        minHeight={80}
        mentionUsers={mentionUsers}
      />
      <div className="flex justify-end">
        <Button size="sm" onClick={handleSubmit} disabled={loading}>
          {loading ? 'Posting...' : 'Post Comment'}
        </Button>
      </div>
    </div>
  )
}

export default TaskComments
